export default function GGContact() {
  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-violet-600 tracking-widest uppercase mb-2 block">Contact Us</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">联系政务团队</h2>
          <p className="text-slate-500 text-sm">政务项目需结合您的业务场景深度定制，欢迎联系我们的专业顾问团队</p>
        </div>
        <div className="grid grid-cols-2 gap-8 mb-10">
          <div className="bg-gradient-to-br from-[#1a0a3a] to-[#2d1060] rounded-2xl p-7 text-white">
            <h3 className="text-lg font-bold mb-6">合作咨询</h3>
            <div className="space-y-4">
              {[
                { icon: "ri-phone-line", label: "政务专线", value: "400-888-0001" },
                { icon: "ri-mail-line", label: "邮箱", value: "gov@platform.cn" },
                { icon: "ri-time-line", label: "服务时间", value: "工作日 8:30 - 18:00" },
                { icon: "ri-map-pin-line", label: "总部地址", value: "北京市海淀区中关村软件园" },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 flex-shrink-0">
                    <i className={`${item.icon} text-amber-300 text-sm`}></i>
                  </div>
                  <div>
                    <div className="text-white/50 text-xs">{item.label}</div>
                    <div className="text-white text-sm font-medium">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-slate-50 rounded-2xl p-7 border border-slate-100">
            <h3 className="text-slate-800 font-bold text-base mb-5">申请试点方案</h3>
            <div className="space-y-3">
              <div>
                <label className="text-xs text-slate-600 font-medium block mb-1">您的姓名</label>
                <input type="text" placeholder="请输入姓名" className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-800 bg-white outline-none focus:border-violet-400 transition-colors" />
              </div>
              <div>
                <label className="text-xs text-slate-600 font-medium block mb-1">所在单位</label>
                <input type="text" placeholder="如：XX市XX区政务服务中心" className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-800 bg-white outline-none focus:border-violet-400 transition-colors" />
              </div>
              <div>
                <label className="text-xs text-slate-600 font-medium block mb-1">联系电话</label>
                <input type="text" placeholder="请输入手机号" className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-800 bg-white outline-none focus:border-violet-400 transition-colors" />
              </div>
              <div>
                <label className="text-xs text-slate-600 font-medium block mb-1">需求简述</label>
                <textarea rows={3} placeholder="请简要描述您的业务场景和需求..." maxLength={500} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-800 bg-white outline-none focus:border-violet-400 transition-colors resize-none"></textarea>
              </div>
              <button className="w-full bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-500 hover:to-purple-500 text-white py-2.5 rounded-lg text-sm font-semibold cursor-pointer whitespace-nowrap transition-all">
                提交申请
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-4 gap-4">
          {[
            { icon: "ri-award-line", color: "text-amber-500 bg-amber-50", label: "国家电子政务认证", sub: "通过三级等保" },
            { icon: "ri-cloud-line", color: "text-blue-500 bg-blue-50", label: "支持私有化部署", sub: "数据不出内网" },
            { icon: "ri-customer-service-line", color: "text-violet-500 bg-violet-50", label: "驻场实施服务", sub: "专项团队支持" },
            { icon: "ri-file-paper-line", color: "text-emerald-500 bg-emerald-50", label: "完整培训体系", sub: "网格员培训手册" },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-3 bg-slate-50 rounded-xl p-4 border border-slate-100">
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${item.color}`}>
                <i className={`${item.icon} text-base`}></i>
              </div>
              <div>
                <div className="text-slate-700 text-xs font-semibold">{item.label}</div>
                <div className="text-slate-400 text-xs">{item.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
